import { render, staticRenderFns } from "./ScreenRecorder.vue?vue&type=template&id=a2f86940&scoped=true"
import script from "./ScreenRecorder.vue?vue&type=script&lang=js"
export * from "./ScreenRecorder.vue?vue&type=script&lang=js"
import style0 from "./ScreenRecorder.vue?vue&type=style&index=0&id=a2f86940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f86940",
  null
  
)

export default component.exports